export default {
  getAccountTrendList: ({ accountTrendList }) => {
    return accountTrendList;
  },
  getAccountDiffList: ({ accountDiffList }) => {
    return accountDiffList;
  },
  getAccountStatusList: ({ accountStatusList }) => {
    return accountStatusList;
  },
  getAccountCspStatusList: ({ accountCspStatusList }) => {
    return accountCspStatusList;
  },
}



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/summary/accountDivisionGetter.js